<script lang="ts">
  import { procentPassed } from "../../store"

  $: isMobile = (Math.min(window.screen.width, window.screen.height) < 576) as boolean
</script>

<div class="progress-bar">
  <div class="wrapper">
    <div class="progress" style:width={`${$procentPassed === 0 ? isMobile ? 8 : 4 : $procentPassed}%`} />
    <div class="indicator">{$procentPassed}%</div>
  </div>
</div>

<style lang="scss">
  * {
    box-sizing: border-box;
  }

  .progress-bar {
    margin-top: 24px;
    padding-bottom: 4px;

    @media (max-width: 576px) {
      padding-bottom: 12px;
    }
  }

  .wrapper {
    height: 24px;
    width: 100%;
    border-radius: 70px;
    background-color: #E0E8F6;
    box-shadow: -2px 4px 10px 0px #CAD8EF inset;
    display: flex;

    .progress {
      height: 24px;
      border-radius: 70px;
      background: linear-gradient(0deg, #576CED, #576CED), linear-gradient(0deg, #2B50ED, #2B50ED);
      border: 2px solid #2B50ED;
      margin-right: -30px;
    }

    .indicator {
      height: 24px;
      border-radius: 70px;
      padding: 8px 12px 8px 12px;
      background: #2B50ED;
      border: 1px solid #2B50ED;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
    }
  }
</style>